import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../config";
import {
  getClassificationTaxonomy,
  getObjectPresenceTaxonomy,
} from "../requests/taxonomy.requests";

export const useGetClassificationTaxonomy = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.CLASSIFICATION_TAXONOMY],
    queryFn: getClassificationTaxonomy,
    staleTime: 1000 * 60 * 10, // 10 minutes
    refetchOnWindowFocus: true,
  });
};

export const useGetObjectPresenceTaxonomy = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.OBJECT_PRESENCE_TAXONOMY],
    queryFn: getObjectPresenceTaxonomy,
    staleTime: 1000 * 60 * 10, // 10 minutes
    refetchOnWindowFocus: true,
  });
};
